<div>
  <div class="d-flex align-items-center" *ngIf="Profilo && ActiveId == 'info'">
    <button type="submit" (click)="saveClick()" class="ml-auto btn  btn-success waves-effect waves-light save-button">
      <span class="ml-1 text-white "> {{'cliente.save' | translate}} </span>
      <i-feather name="save" class="feather-md "></i-feather>
    </button>
  </div>
  <div class="card mt-1">
    <ul ngbNav #nav="ngbNav" [(activeId)]="ActiveId" class="nav-tabs">
      <li ngbNavItem="info">
        <a *ngIf="!environment.ClientiAddOn['hideNomeTab']" ngbNavLink> {{selected?.nominativo != null &&
          selected?.nominativo != "" ? selected?.nominativo : 'Anagrafica' | translate}} {{ selected['data'] ? "(":"" }}
          {{selected['data'] | date: "dd/MM/yyyy"}} {{ selected['data'] ? ")":"" }}</a>
        <a class="text-center" *ngIf="environment.ClientiAddOn['hideNomeTab']" ngbNavLink> {{selected?.nominativo?.length ? (selected.fullName ?? selected?.nominativo) : '' }} <br *ngIf="selected?.nominativo?.length"> Informazioni socio-anagrafiche {{
          selected['data'] ? "(":"" }} {{selected['data'] | date: "dd/MM/yyyy"}} {{ selected['data'] ? ")":"" }}</a>
        <ng-template ngbNavContent *ngIf="!environment.ClientiAddOn['SezioniInfo']">
          <div class="card col-sm-12 col-md-12">
            <div class="card-body">
              <div class="d-md-flex align-items-center justify-content-end" style="padding-right: 0px;">
                <!--<button type="submit" *ngIf="!Profilo && !Readonly" (click)="saveClick(true)" style="padding: 0 !important; margin-right: 0;" class=" btn   p-2 waves-effect waves-light">
                  <i-feather name="save" class="feather-md " style="color: #28a745"></i-feather>
                </button>-->

              </div>
              <div class="row" style="margin-top: 0">
                <div class="col-sm-12 col-lg-3">
                  <div class="form-group">
                    <label for="ragione_sociale" class="control-label col-form-label"> * {{'cliente.nominativo' |
                      translate}}:</label>
                    <input [(ngModel)]="selected.nominativo" [disabled]="Readonly"
                      (ngModelChange)="OnNominativoChange()" required #nominativo="ngModel" type="text"
                      class="form-control" id="ragione_sociale" placeholder="{{'cliente.nominativo' | translate}}">
                    <small class="form-text text-danger" *ngIf=" !nominativo.valid && !Readonly">Campo
                      richiesto!</small>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3">
                  <div class="form-group">
                    <label for="email" class="control-label col-form-label"> * {{'cliente.email' | translate}}:</label>
                    <input [(ngModel)]="selected.email" [disabled]="Readonly" type="email" class="form-control"
                      id="email" placeholder="{{'cliente.email' | translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3" *ngIf="!environment.ClientiAddOn['hidepiva']">
                  <div class="form-group">
                    <label for="partita_iva" class="control-label col-form-label">{{'cliente.piva' |
                      translate}}:</label>
                    <input [(ngModel)]="selected.piva" [disabled]="Readonly" required #piva="ngModel" type="text"
                      class="form-control" id="partita_iva" placeholder="{{'cliente.piva' | translate}}">
                    <!--              <small class="form-text text-danger" *ngIf="!piva.valid ">Campo richiesto!</small>-->
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3" *ngIf="environment.ClientiAddOn['cf']">
                  <div class="form-group">
                    <label for="codice_fiscale" class="control-label col-form-label">{{'cliente.cf' |
                      translate}}:</label>
                    <input [(ngModel)]="selected.cf" [disabled]="Readonly" required #cf="ngModel" type="text"
                      class="form-control" id="codice_fiscale" placeholder="{{'cliente.cf' | translate}}">
                    <!--              <small class="form-text text-danger" *ngIf="!cf.valid ">Campo richiesto!</small>-->
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3" *ngIf="environment.ClientiAddOn['codice_univoco']">
                  <div class="form-group">
                    <label for="codice_univoco" class="control-label col-form-label">{{'cliente.codice_univoco' |
                      translate}}:</label>
                    <input [(ngModel)]="selected.codice_univoco" [disabled]="Readonly" type="text" class="form-control"
                      id="codice_univoco" placeholder="{{'cliente.codice_univoco' | translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3"
                  *ngIf="ClientiAddOn.codAdhoc && !Profilo && !permission.isOperativeRole('AG')">
                  <div class="form-group">
                    <label class="control-label col-form-label">{{'adhocCode' | translate}}:</label>
                    <input [(ngModel)]="selected.codAdhoc" [disabled]="Readonly" type="text" class="form-control"
                      id="adhoc" placeholder="{{'adhocCode' | translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3">
                  <div class="form-group">
                    <label for="pec" class="control-label col-form-label">{{'cliente.pec' | translate}}:</label>
                    <input [(ngModel)]="selected.pec" [disabled]="Readonly" type="email" class="form-control" id="pec"
                      placeholder="{{'cliente.pec' | translate}}">
                  </div>
                </div>

                <div class="col-lg-3">
                  <div class="form-group">
                    <label for="telefono" class="control-label col-form-label">{{'cliente.telefono' |
                      translate}}:</label>
                    <input [(ngModel)]="selected.telefono" [disabled]="Readonly" type="text" class="form-control"
                      id="telefono" placeholder="{{'cliente.telefono' | translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3" *ngIf="tipologieSedi && environment.ClientiAddOn.TipoSedePrimaria">
                  <div class="">
                    <label class="control-label col-form-label">{{'cliente.sede' | translate}}:</label>
                    <ng-multiselect-dropdown [settings]="dropdownSettings" [disabled]="Readonly"
                      [placeholder]="'Seleziona'" name="sede" [data]="tipologieSedi"
                      [(ngModel)]="tipologieSediSelezionate">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3">
                  <div class="form-group">
                    <label for="indirizzo" class="control-label col-form-label">{{'cliente.indirizzo' |
                      translate}}:</label>
                    <input [(ngModel)]="selected.indirizzo" [disabled]="Readonly" type="text" class="form-control"
                      id="indirizzo" placeholder="{{'cliente.indirizzo' | translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-lg-1">
                  <div class="form-group">
                    <label for="cap" class="control-label col-form-label">{{'cliente.cap' | translate}}:</label>
                    <input [(ngModel)]="selected.cap" [disabled]="Readonly" type="text" class="form-control" id="cap"
                      placeholder="{{'cliente.cap' | translate}}">
                  </div>
                </div>

                <div class="col-sm-12 col-lg-2" *ngIf="!environment.ClientiAddOn['provinciaArray']">
                  <div class="form-group">
                    <label for="provincia" class="control-label col-form-label">{{'cliente.provincia' |
                      translate}}:</label>
                    <input [(ngModel)]="selected.provincia" [disabled]="Readonly" type="text" class="form-control"
                      id="provincia" placeholder="{{'cliente.provincia' | translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-lg-2" *ngIf="environment.ClientiAddOn['provinciaArray']">
                  <div class="form-group">
                    <label for="provincia" class="control-label col-form-label">{{'cliente.provincia' |
                      translate}}:</label>
                    <ng-multiselect-dropdown [settings]="ProvdropdownSettings" [disabled]="Readonly" [placeholder]="''"
                      name="sede" [data]="Provincie" [(ngModel)]="Provincia">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3">
                  <div class="form-group">
                    <label for="citta" class="control-label col-form-label">{{'cliente.citta' | translate}}:</label>
                    <input [(ngModel)]="selected.citta" [disabled]="Readonly" type="text" class="form-control"
                      id="citta" placeholder="{{'cliente.citta' | translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-lg-1"
                  *ngIf="environment.ClientiAddOn['checkAmm'] &&  !permission.isOperativeRole('AG')">
                  <div class="form-group">
                    <label for="checkAmm" class="control-label col-form-label">{{'cliente.checkAmm' |
                      translate}}:</label>
                    <input [(ngModel)]="selected.checkAmm" [disabled]="Readonly" type="checkbox" class="form-control"
                      id="checkAmm" placeholder="{{'cliente.checkAmm' | translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3"
                  *ngIf="environment.ClientiAddOn['iva'] &&  !permission.isOperativeRole('AG')">
                  <div class="form-group">
                    <label for="checkAmm" class="control-label col-form-label">{{'cliente.iva' | translate}}:</label>
                    <input [(ngModel)]="selected.iva" [disabled]="Readonly" type="number" class="form-control" id="iva"
                      placeholder="{{'cliente.iva' | translate}}">
                  </div>
                </div>
              </div>
              <app-field-viewer *ngIf="selected && environment.ClientiAddOn['CampiAggiuntivi']"
                [Campi]="environment.ClientiAddOn['CampiAggiuntivi']" [(Oggetto)]="selected"></app-field-viewer>
              <div class="row">
                <div class="col-sm-12 col-lg-12" *ngIf="hasRoles && !type && !Profilo">
                  <div class="">
                    <label class="control-label col-form-label">{{'cliente.ruoli' | translate}}:</label>
                    <ng-multiselect-dropdown [settings]="roledropdownSettings" [disabled]="Readonly"
                      [placeholder]="'Seleziona'" name="ruoli" [data]="ruoliCliente" [(ngModel)]="ruoloCliente">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 " *ngIf="ShowRuoliAccesso()">
                  <label for="ra" class="control-label col-form-label">Ruoli di Accesso:</label>
                  <ng-multiselect-dropdown required #ra="ngModel" [disabled]="Readonly"
                    [settings]="ruoloAccessoDropdownSettings" [placeholder]="'Seleziona'" id="ra" name="tipo"
                    [data]="listaruoliaccesso" [(ngModel)]="listaruoliaccessoselezionati">
                  </ng-multiselect-dropdown>
                  <small class="form-text text-danger"
                    *ngIf="selected.email?.length > 0 && selected.username?.length > 0 && (!listaruoliaccessoselezionati || listaruoliaccessoselezionati.length <= 0)">Campo
                    richiesto!</small>
                </div>
                <div class="col-sm-12 col-lg-12"
                  *ngIf="(!type || type != 'f') && !Profilo && tipologieAsObj?.length > 0">
                  <div *ngIf="tipologieAsObj" class="">
                    <label class="control-label col-form-label">{{'cliente.tipo' | translate}}:</label>
                    <ng-multiselect-dropdown [settings]="dropdownSettings" [disabled]="Readonly"
                      [placeholder]="'Seleziona'" [data]="tipologieAsObj" [(ngModel)]="selectedItems"
                      (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-lg-3 form-group " *ngIf="environment.ClientiAddOn['emailAccount']">
                  <label class="mb-0 text-dark">{{'cliente.emailAccount' | translate}}:</label>
                  <input [(ngModel)]="selected.emailAccount" [disabled]="Readonly" #username="ngModel" type="text"
                    name="emailAccount" class="form-control" placeholder="{{'cliente.emailAccount' | translate}}">
                </div>
                <div class="col-lg-3 form-group " *ngIf="environment.ClientiAddOn.accesso">
                  <label class="mb-0 text-dark">{{'cliente.username' | translate}}:</label>
                  <input [(ngModel)]="selected.username" [disabled]="Readonly" #username="ngModel"
                    [readonly]="CredenzialiGiaInserite" type="text" name="username" class="form-control"
                    placeholder="{{'cliente.username' | translate}}">
                </div>
                <div
                  *ngIf="environment.ClientiAddOn.accesso && (!CredenzialiGiaInserite || permission.itsme_mario(selected.id) || permission.hasOperativeRole('SA'))"
                  class="col-lg-3 form-group">
                  <label class="mb-0 text-dark">{{'cliente.password' | translate}}:</label>
                  <input [(ngModel)]="selected.password" [disabled]="Readonly" [type]="!isActive ? 'password' : 'text'"
                    name="password" class="form-control" placeholder="{{'cliente.password' | translate}}">
                </div>
                <div
                  *ngIf="environment.ClientiAddOn.accesso && (!CredenzialiGiaInserite || permission.itsme_mario(selected.id) || permission.hasOperativeRole('SA'))"
                  class="col-lg-3 form-group">
                  <label class="mb-0 text-dark">{{'cliente.cpassword' | translate}}:</label>
                  <input [(ngModel)]="selected.ConfermaPassword" [disabled]="Readonly" #password="ngModel"
                    [type]="!isActive ? 'password' : 'text'" name="password" class="form-control"
                    placeholder="{{'cliente.cpassword' | translate}}">
                </div>
                <div
                  *ngIf="environment.ClientiAddOn.accesso && (!CredenzialiGiaInserite || permission.itsme_mario(selected.id) || permission.hasOperativeRole('SA'))"
                  class="col-lg-1 d-flex justify-content-center align-items-center ">
                  <input [(ngModel)]="isActive" type="checkbox" [disabled]="Readonly" id="mostra" name="password"
                    class="">
                  &nbsp;
                  <label for="mostra" class="mb-0 text-dark">{{'cliente.mpassword' | translate}}:</label>
                </div>
                <div class="col-lg-12"
                  *ngIf=" !environment.ClientiAddOn.info && environment.ClientiAddOn.note_private && !this.permission.isOperativeRoles(environment.ClientiType)">
                  <div class="row">
                    <div class="col-sm-12 col-md-12">
                      <div class="form-group">
                        <label for="notep" class="control-label col-form-label">{{'cliente.note'|translate}}</label>
                        <textarea rows="5" [(ngModel)]="selected.note" [disabled]="Readonly" type="text"
                          class="form-control" id="notep" placeholder="{{'cliente.note'|translate}}"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <app-field-viewer [(Campi)]="environment.ClientiAddOn['campiAggiuntivi']"
            [(Oggetto)]="selected"></app-field-viewer>
          <div class="card col-sm-12 col-md-12" *ngIf="ClientiAddOn.info">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.compilazione">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.compilazione'|translate}}</label>
                    <input [(ngModel)]="selected.compilazione" type="date" [disabled]="Readonly" class="form-control"
                      placeholder="{{'cliente.compilazione'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.luogoNascita">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.luogoNascita'|translate}}</label>
                    <input [(ngModel)]="selected.luogoNascita" type="text" [disabled]="Readonly" class="form-control"
                      placeholder="{{'cliente.luogoNascita'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.dataNascita">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.dataNascita'|translate}}</label>
                    <input [(ngModel)]="selected.dataNascita" type="date" [disabled]="Readonly" class="form-control"
                      placeholder="{{'cliente.dataNascita'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.statoCivile">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.statoCivile'|translate}}</label>
                    <input [(ngModel)]="selected.statoCivile" type="text" [disabled]="Readonly" class="form-control"
                      placeholder="{{'cliente.statoCivile'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.titoloStudio">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.titoloStudio'|translate}}</label>
                    <input [(ngModel)]="selected.titoloStudio" type="text" [disabled]="Readonly" class="form-control"
                      placeholder="{{'cliente.titoloStudio'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.invalidita">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.invalidita'|translate}}</label>
                    <input [(ngModel)]="selected.invalidita" type="checkbox" [disabled]="Readonly" class="form-control"
                      placeholder="{{'cliente.invalidita'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.legge104">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.legge104'|translate}}</label>
                    <input [(ngModel)]="selected.legge104" type="checkbox" [disabled]="Readonly" class="form-control"
                      placeholder="{{'cliente.legge104'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.diagnosi">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.diagnosi'|translate}}</label>
                    <input [(ngModel)]="selected.diagnosi" type="text" [disabled]="Readonly" class="form-control"
                      placeholder="{{'cliente.diagnosi'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn['cittadinanza']">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.cittadinanza'|translate}}</label>
                    <input [(ngModel)]="selected['cittadinanza']" type="text" [disabled]="Readonly" class="form-control"
                      placeholder="{{'cliente.cittadinanza'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.accompagnamento">
                  <div class="form-group">
                    <label for="notep"
                      class="control-label col-form-label">{{'cliente.accompagnamento'|translate}}</label>
                    <input [(ngModel)]="selected.accompagnamento" [disabled]="Readonly" type="checkbox"
                      class="form-control" placeholder="{{'cliente.accompagnamento'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.pensione">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.pensione'|translate}}</label>
                    <input [(ngModel)]="selected.pensione" [disabled]="Readonly" type="checkbox" class="form-control"
                      placeholder="{{'cliente.pensione'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.tutelare">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.tutelare'|translate}}</label>
                    <input [(ngModel)]="selected.tutelare" [disabled]="Readonly" type="text" class="form-control"
                      placeholder="{{'cliente.tutelare'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.medico">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.medico'|translate}}</label>
                    <input [(ngModel)]="selected.medico" [disabled]="Readonly" type="text" class="form-control"
                      placeholder="{{'cliente.medico'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.telMedico">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.telMedico'|translate}}</label>
                    <input [(ngModel)]="selected.telMedico" [disabled]="Readonly" type="text" class="form-control"
                      placeholder="{{'cliente.telMedico'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-md-3" *ngIf="ClientiAddOn.terapia">
                  <div class="form-group">
                    <label for="notep" class="control-label col-form-label">{{'cliente.terapia'|translate}}</label>
                    <input [(ngModel)]="selected.terapia" [disabled]="Readonly" type="text" class="form-control"
                      placeholder="{{'cliente.terapia'|translate}}">
                  </div>
                </div>
                <div class="col-sm-12 col-lg-4" *ngIf="(!type || type != 'f') && environment.ClientiAddOn.commerciale">
                  <div *ngIf="listaNomiPersonale" class="">
                    <label class="control-label col-form-label"> {{'cliente.commerciale'|translate}}</label>
                    <ng-multiselect-dropdown [settings]="utentidropdownSettings" [disabled]="Readonly"
                      [placeholder]="'Seleziona'" name="commerciale" [data]="listaNomiPersonale"
                      [(ngModel)]="commercialeselezionato" (onFilterChange)="filtroCommerciale($event)">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-4" *ngIf="(!type || type != 'f') && environment.ClientiAddOn.segnalatore">
                  <div *ngIf="listaNomiClienti" class="">
                    <label class="control-label col-form-label">{{'cliente.segnalatore'|translate}}</label>
                    <ng-multiselect-dropdown [placeholder]="'Seleziona'" name="segnalatore"
                      [settings]="clientidropdownSettings" [disabled]="Readonly" [data]="listaNomiClienti"
                      [(ngModel)]="segnalatoreselezionato" (onFilterChange)="filtrosegnalatore($event)">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-4"
                  *ngIf="(!type || type != 'f' ) && environment.ClientiAddOn.segnalatoreInterno && (permission.isntOperativeRole('AG') || permission.isOperativeRole('SA'))">
                  <div *ngIf="listaNomiPersonale" class="">
                    <label class="control-label col-form-label">{{'cliente.segInterno'|translate}}</label>
                    <ng-multiselect-dropdown [settings]="utentidropdownSettings" [disabled]="Readonly"
                      [placeholder]="'Seleziona'" name="internal_seg" [data]="listaNomiPersonale"
                      [(ngModel)]="segnalatoreinternoselezionato" (onFilterChange)="filtrosegnalatoreInterno($event)">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
              </div>
              <div class="row"
                *ngIf="(environment.ClientiAddOn.note_private && this.permission.isOperativeRoles(environment.ClientiType) ) || !environment.ClientiAddOn.note_private">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label for="note" class="control-label col-form-label">{{'cliente.note'|translate}}</label>
                    <textarea rows="5" [(ngModel)]="selected.note" [disabled]="Readonly" type="text"
                      class="form-control" id="note" placeholder="{{'cliente.note'|translate}}"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-md-12"><br></div>
              <div class="col-md-12"
                *ngIf="environment.ClientiAddOn.rating && !this.permission.isOperativeRoles(environment.ClientiType)">
                <ngb-rating [(rate)]="selected.rate"></ngb-rating>
                <div class="m-t-10">Rate: <b>{{selected.rate}}</b></div>
              </div>
              <div class="col-lg-12"
                *ngIf=" environment.ClientiAddOn.rating && !this.permission.isOperativeRoles(environment.ClientiType)">
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <div class="form-group">
                      <label for="noter" class="control-label col-form-label">{{'cliente.note'|translate}}
                        Rating</label>
                      <textarea rows="5" [(ngModel)]="selected.noteRate" type="text" class="form-control" id="noter"
                        placeholder="{{'cliente.note'|translate}}"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-12" *ngIf="ClientiAddOn['congelamento']">
                <div class="form-group">
                  <label for="notep" class="control-label col-form-label">Note
                    {{'cliente.sezioni.congelamenti'|translate}}</label>
                  <textarea [(ngModel)]="selected['noteCheck']" [disabled]="Readonly" type="text" class="form-control"
                    placeholder="Note {{'cliente.sezioni.congelamenti'|translate}}"></textarea>
                </div>
              </div>
              <!--              <div class="d-md-flex align-items-center" style="padding-right: 25px;">-->
              <!--                <button type="submit" (click)="saveClick()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">-->
              <!--                  <span class="ml-1 text-white font-weight-bold"> Salva </span>-->
              <!--                  <i-feather name="save" class="feather-md "></i-feather>-->
              <!--                </button>-->
              <!--              </div>-->
            </div>
          </div>
        </ng-template>
        <ng-template ngbNavContent *ngIf="environment.ClientiAddOn['SezioniInfo']">
          <div class="card">
            <div class="card-body">
              <app-sector-viewer [(DropdownSources)]="DropdownSources" (OnFilter)="FilterHandler($event)"
                (OnChange)="ChangeHandler($event)" [(Campi)]="environment.ClientiAddOn['SezioniInfo']"
                [(Oggetto)]="selected"></app-sector-viewer>
              <div>
                <h5 class card-title style="font-weight: 700; padding: 0.8rem; background-color: whitesmoke">Referenti
                </h5>
                <app-referenti
                  *ngIf="!showaddform && selected && ClientiAddOn['referentiInInfo'] &&  selected.id && (ClientiAddOn.referenti || permission.hasOperativeRole('SA')) && !Readonly"
                  [(Lista)]="selected.referenti" [Cliente]="selected.id" (Refresh)="refresh()"></app-referenti>

              </div>
            </div>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="Attività" *ngIf="!showaddform && selected && ClientiAddOn.attivita && !Readonly">
        <a ngbNavLink> {{'cliente.sezioni.attivita'|translate}} </a>
        <ng-template ngbNavContent>
          <app-attivita-cliente *ngIf="!env.TaskAddon || !env.TaskAddon['Crm']?.enabled" [clienteSelezionato]="selected"></app-attivita-cliente>
          <app-Crm *ngIf="env.TaskAddon && env?.TaskAddon['Crm']?.enabled" [clienteSelezionato]="selected" [(Attivita)]="selected.attivita" (Refresh)="refresh()"></app-Crm>
        </ng-template>
      </li>
      <li ngbNavItem="Questionario"
        *ngIf="((!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || (selected['dataInserimento'])) && !showaddform && selected && ClientiAddOn['questionario'] && idCongelamento">
        <a ngbNavLink> {{'cliente.sezioni.questionario'|translate}} </a>
        <ng-template ngbNavContent>
          <app-questionario [FirstCatIsTab]="true" [isModifyDisabled]="Readonly"
            restroute="/anagrafica/clienti/checklist" [filter]="{congelamento: idCongelamento}"
            (CheckListChange)="ChecklistChanged($event)"></app-questionario>
        </ng-template>
      </li>
      <li ngbNavItem="Questionario"
        *ngIf="((!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || ( selected['dataInserimento'])) && !showaddform && selected && ClientiAddOn['questionario'] && !idCongelamento">
        <a ngbNavLink> {{'cliente.sezioni.questionario'|translate}} </a>
        <ng-template ngbNavContent>
          <app-questionario [FirstCatIsTab]="true" [isModifyDisabled]="Readonly"
            restroute="/anagrafica/clienti/checklist" [Congelamenti]="selected.congelamenti"
            [filter]="{id: selected?.id}" (CheckListChange)="ChecklistChanged($event)"></app-questionario>
        </ng-template>
      </li>
      <li ngbNavItem="ptr"
        *ngIf="((!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || ( selected['dataInserimento'])) && !showaddform && selected && ClientiAddOn['ptr'] && !Readonly">
        <a ngbNavLink> {{'cliente.sezioni.ptr'|translate}} </a>
        <ng-template ngbNavContent>
          <app-check-per-data [cliente]="selected.id" [clienteObject]="selected"></app-check-per-data>
        </ng-template>
      </li>
      <ng-container
        *ngIf="(!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || (selected['dataInserimento']) && environment.ClientiAddOn['Tabs'] && selected?.id ">
        <li [ngbNavItem]="tab.titolo" *ngFor="let tab of environment.ClientiAddOn['Tabs']">
          <a ngbNavLink> {{tab.titolo|translate}} </a>
          <ng-template ngbNavContent *ngIf=" tab.tipo == 'task'">
            <app-field-viewer *ngIf="selected && tab.CampiAggiuntivi" [(DropdownSources)]="DropdownSources"
              (OnFilter)="FilterHandler($event)" (OnChange)="ChangeHandler($event)" [Campi]="tab.CampiAggiuntivi"
              [(Oggetto)]="selected"></app-field-viewer>
            <app-list *ngIf="tab.params" [cliente]="selected.id" [clienteObject]="selected" [type]="tab.params.tipo"
              [filter]="tab.params.filter ?? 0" [filtri]="tab.filtri " [headers]="tab.headers" [title]="tab.titolo"
              [DisableEdit]="tab.DisableEdit"></app-list>
          </ng-template>
          <ng-template ngbNavContent *ngIf="tab.tipo == 'sezioni' && tab.sezioni">
            <app-sector-viewer [(Oggetto)]="selected" [Campi]="tab.sezioni" [DropdownSources]="{}"
              (OnChange)="OnChange.emit($event)"></app-sector-viewer>
          </ng-template>
        </li>
      </ng-container>
      <li ngbNavItem="ProvaAcquisto"
        *ngIf="((!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || (selected['dataInserimento'])) && !showaddform && selected && ClientiAddOn.prodotti && environment.RmaAddOn.provaAcquisto&& !Readonly ">
        <a ngbNavLink> {{'provaAcquisto.title'|translate}} </a>
        <ng-template ngbNavContent>
          <app-lista-prova-acquisto [Cliente]="selected"></app-lista-prova-acquisto>
        </ng-template>
      </li>
      <ng-container
        *ngIf="(!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || (selected['dataInserimento']) && !showaddform && selected?.id && (ClientiAddOn.rma || permission.isOperativeRoles(['C', 'AC']))&& (!Readonly || permission.isOperativeRoles(['U']))">
        <li ngbNavItem="Rmatasklist" *ngIf="RmaListType == 'task'">
          <a ngbNavLink> {{'cliente.sezioni.rma'|translate}} </a>
          <ng-template ngbNavContent>
            <app-list [cliente]="selected.id" [type]="'R'" [filter]="'RA'"></app-list>
          </ng-template>
        </li>
        <li ngbNavItem="Rma" *ngIf="RmaListType == 'rma'">
          <a ngbNavLink> {{'cliente.sezioni.rma'|translate}} </a>
          <ng-template ngbNavContent>
            <app-rma-list [filtri]="{page:0, size:100, tipo: 'R', cliente: selected.id, figli: false}"></app-rma-list>
          </ng-template>
        </li>
      </ng-container>


      <li ngbNavItem="Task"
        *ngIf="((!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || (selected['dataInserimento'])) && !showaddform && selected && hasInterventi&& !Readonly">
        <a ngbNavLink> {{'cliente.sezioni.task'|translate}} </a>
        <ng-template ngbNavContent>
          <app-lista-interventi-offerta [Cliente]="true"></app-lista-interventi-offerta>
        </ng-template>
      </li>
      <li ngbNavItem="offerte"
        *ngIf="((!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || (selected['dataInserimento'])) && !showaddform && selected && ClientiAddOn.interventi && permission.isPermitted('menu-progetti')&& !Readonly">
        <a ngbNavLink> {{'cliente.sezioni.offerte'|translate}} </a>
        <ng-template ngbNavContent>
          <app-lista-progetti [cliente]="selected.nominativo" [hasHeader]="false"></app-lista-progetti>
        </ng-template>
      </li>
      <li ngbNavItem="Files"
        *ngIf="(!selected['dataPreInserimento'] && selected?.id) || (selected['dataPreInserimento']) && selected.id && permission.isPermitted('lista-file') && (!Readonly || permission.isOperativeRoles(['U']))">
        <a ngbNavLink> {{'cliente.sezioni.files'|translate}} </a>
        <ng-template ngbNavContent>
          <app-file-uploader [WriteOnlyMy]="permission.hasOperativeRoles(environment.ClientiAddOn['fileOnlyMy'])"
            [url]="'/anagrafica/clienti/file'" [id]="selected.id" (onChange)="onFileChanged()"></app-file-uploader>
        </ng-template>
      </li>
      <li ngbNavItem="Congelamenti"
        *ngIf="((!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || (selected['dataPreInserimento'] && selected['dataInserimento'])) && selected.id && environment.ClientiAddOn['congelamento'] && !Readonly">
        <a ngbNavLink> {{'cliente.sezioni.congelamenti'|translate}} </a>
        <ng-template ngbNavContent>
          <div class="table-responsive">
            <table class="table bg-white table-hover align-middle mb-0 no-wrap">
              <thead>
                <tr>
                  <th>Caricato da</th>
                  <th>Data</th>
                  <th scope="col" *ngIf="permission.isPermitted('gestione-clienti')">Azioni</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let co of selected.congelamenti ">
                  <td class="align-middle" (click)='OpenCongelamento(co)'>
                    {{co.utente}}
                  </td>
                  <td class="align-middle" (click)='OpenCongelamento(co)'>
                    {{co.data | date:"dd/MM/yyyy"}}
                  </td>
                  <td class="align-middle" *ngIf="permission.isPermitted('gestione-clienti')">
                    <a href="javascript:void(0)" class="link text-info font-16 font-medium mr-2"
                      (click)='OpenCongelamento(co)'>
                      <i-feather name="edit-3" class="feather-sm"></i-feather>
                    </a>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="Sedi"
        *ngIf="((!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || (selected['dataInserimento'])) && !showaddform && selected && (ClientiAddOn.sedi || permission.hasOperativeRole('SA') ) && !Readonly">
        <a ngbNavLink> {{'cliente.sezioni.sedi'|translate}} </a>
        <ng-template ngbNavContent>
          <app-sedi-aggiuntive [(listaSedi)]="selected.sedi" [client_id]="selected.id" [client]="selected"
            [profile]="Profilo" (Saved)="refresh()"></app-sedi-aggiuntive>
        </ng-template>
      </li>

      <li ngbNavItem="Referenti"
        *ngIf="((!selected['dataPreInserimento'] && !selected['dataInserimento'] && selected?.id) || ( selected['dataInserimento'])) && !showaddform && selected && !ClientiAddOn['referentiInInfo'] &&  selected.id && (ClientiAddOn.referenti || permission.hasOperativeRole('SA')) && !Readonly">
        <a ngbNavLink> {{'cliente.sezioni.referenti' | translate}} </a>
        <ng-template ngbNavContent>
          <app-referenti [(Lista)]="selected.referenti" [Cliente]="selected.id" (Refresh)="refresh()"></app-referenti>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
  <div class="d-md-flex align-items-center justify-content-end" style="padding-right: 0px;"
    *ngIf="!environment.ClientiAddOn['Buttons']?.length">
    <button type="submit"
      *ngIf="!Profilo && !Readonly && (ActiveId == 'info' || ActiveId =='Questionario' || ActiveId =='Terapie e P.V.') "
      (click)="saveClick(true)" class=" btn  btn-success p-2 waves-effect waves-light">
      <span class="ml-1 text-white font-weight-bold"> {{'cliente.saveAndClose' | translate}} </span>
      <i-feather name="save" class="feather-md "></i-feather>
    </button>
    <button type="submit"
      *ngIf="!Profilo && !Readonly && (ActiveId == 'info' || ActiveId =='Questionario' || ActiveId =='Terapie e P.V.')"
      (click)="saveClick()" class=" btn btn-rounded btn-success p-2 waves-effect waves-light">
      <span class="ml-1 text-white font-weight-bold"> {{'cliente.save' | translate}} </span>
      <i-feather name="save" class="feather-md "></i-feather>
    </button>
    <button type="submit"
      *ngIf="!Profilo && environment.ClientiAddOn['congelamento'] && !Readonly && (ActiveId == 'info' || ActiveId =='Questionario')"
      (click)="saveClick(false,true)" class=" btn btn-rounded btn-success p-2 waves-effect waves-light">
      <span class="ml-1 text-white font-weight-bold"> {{'cliente.freeze' | translate}} </span>
      <i-feather name="save" class="feather-md "></i-feather>
    </button>
    <button type="submit" *ngIf=" environment.ClientiAddOn.enable && !Readonly && !selected.active && selected?.id "
      (click)="enable(selected)" class=" btn btn-rounded btn-success p-2 waves-effect waves-light">
      <span class="ml-1 text-white font-weight-bold"> Abilita </span>
      <i class="fas fa-check-circle"></i>
    </button>
    <button type="submit" *ngIf=" environment.ClientiAddOn.enable && !Readonly && selected.active && selected?.id "
      (click)="disable(selected)" class=" btn btn-rounded btn-danger p-2 waves-effect waves-light">
      <span class="ml-1 text-white font-weight-bold"> Disabilita </span>
      <i class="fas fa-check-circle"></i>
    </button>
  </div>
  <div class="d-md-flex align-items-center justify-content-end" *ngIf="environment.ClientiAddOn['Buttons']?.length">
    <app-dynamic-buttons [component]="this" [Azioni]=" environment.ClientiAddOn['Buttons']" [(Item)]="selected"
      [(ActiveID)]="ActiveId" [CustomHandle]="CustomButton"></app-dynamic-buttons>
  </div>



</div>